// Runtime configuration, provided by public/config.js (see that file for details).
const runtime = (typeof window !== 'undefined' && window.__QUIZ_CONFIG__) || {};

export const config = {
    quizGetUrl: runtime.quizGetUrl,
    quizPostUrl: runtime.quizPostUrl,
};
